
import React from "react";
import { forwardRef } from 'react';
import { useState } from "react";
import { faAngleDoubleDown, faAngleDoubleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const StatsBox = forwardRef(({ title, children, backgroundColor = "white", hide=false }, ref) => {

  const [contentVisible, setContentVisible] = useState(true);

  return (
    <div className="stats-box" style={{ backgroundColor }} ref={ref}>
      <h2 className="stats-title">{title}</h2>
      {contentVisible ? <div className="stats-content">{children}</div> : <div>....</div>}
      {hide && (<div className="stats-hide-area" style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                className="basic-button" onClick={() => setContentVisible(!contentVisible)}>
              {contentVisible ? (
                  <>
                    <FontAwesomeIcon icon={faAngleDoubleUp} id="up" /> Hide Details
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faAngleDoubleDown} id="down" /> Show Details
                  </>
                )}
                </button>
                </div>
      )}
    </div>
  );
});
StatsBox.displayName = "StatsBox";

export default StatsBox;